import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Drawer } from "@material-ui/core";
import { Text, SVG, SelectBox } from "sunrise-ui";
import PilesDrawer from "./Drawer/PliesDrawer";
import List from "./List";
import { AppDispatch } from "../../redux/store";

// API Calls
import {
  getCompletedPilesData,
  getCompletedPilesTableData,
  getStepsDropList,
} from "../../redux/reducers/dashboardReducers";

const CompletedPiles = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const [drawerData, setDrawerData] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [delayReasonsPerRow, setDelayReasonPerRow] = useState<any[]>([]);
  const [itemsData, setItemsData] = useState<any[]>([]);
  const [dataToDownload, setDataToDownload] = useState([]);
  const openDrawer = (data: any) => {
    setDrawerData(data);
    setDrawerOpen(true);
  };

  const getRowIndex = (id: any) => {
    return completedPilesTableData.findIndex((val: any) => val.id === id);
  };

  const handleChange = (id: any, name: any) => {
    const index = getRowIndex(id);
    const itemsList = completedPilesTableData[index]?.delay;
    let data = itemsList?.find((val: any) => val.delayedAgencyName === name);
    data = { id, item: data };
    const list: any = [...itemsData];
    list[index] = data;
    setItemsData(list);
  };

  const completedPilesData = useSelector(
    (state: any) => state.DASHBOARD.completedPilesData
  );
  const completedPilesTableData = useSelector(
    (state: any) => state.DASHBOARD.completedPilesTableData
  );
  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);

  const renderValue = (obj: any, id: any) => {
    const index = delayReasonsPerRow?.findIndex((val: any) => val.id === id);
    if (index) {
      if (delayReasonsPerRow[index] !== undefined) {
        return delayReasonsPerRow[index][obj];
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(allProject)) {
      const project_id: any = allProject?.find(
        (val: any) => val?.projectName === props?.projectName
      )?._id;
      if (project_id) {
        dispatch(
          getCompletedPilesData({
            endPoint: `piles/overview?status=COMPLETED&project=${project_id}`,
          })
        );
        // to get table data
        dispatch(
          getCompletedPilesTableData({
            endPoint: `piles?status=COMPLETED&project=${project_id}`,
          })
        ).then(() => {
          setDelayReasonPerRow(
            completedPilesTableData?.rows?.map((val: any, index: any) => val.id)
          );
        });
      }
    }
    // eslint-disable-next-line
  }, [props.projectName]);

  useEffect(() => {
    setItemsData(() =>
      completedPilesTableData.map((val: any) => ({
        id: val?.id,
        item: val.delay[0],
      }))
    );
  }, [completedPilesTableData]);
  useEffect(()=>{
    let downloadData = completedPilesTableData.map((ele:any)=>{
      return {
        'Pile Id': ele.pileId,
        'Work Started By':ele.workStartedBy,
        'Work Completed By':ele.workCompletedBy,
        'RIG Used':ele.rigUsed,
        'Pile Status':ele.pileStatus,
        'Pile Filling Started On':ele.pileStartedOn,
        'Pile Cycle (Hrs)':ele.pileCycleHours,
        'Last Worked By':ele.workCompletedBy,
        'Pile Started on':ele.pileStartedOn,
        'Pile Completed on':ele.pileCompletedOn,
        'Delay Agency':ele.delay.map((ele2:any)=>{return `${ele2.delayedAgencyName}`}),
        'Delay Reason':ele.delay.map((ele2:any)=>{return `${ele2.delayReason}`}),
      }
    })
    setDataToDownload(downloadData)
  },[completedPilesTableData])
  const fields = [
    {
      header: "Pile Id",
      value: "pileId",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="link"
            fonts="normal"
            className={`mb0 mt0`}
            fontSize={14}
            onTextClick={() => {
              dispatch(
                getStepsDropList({
                  endPoint: `piles/steps-filter?pileId=${obj?.id}`,
                })
              ).then(() => openDrawer(obj));
            }}
          >
            {obj?.pileId}
          </Text>
        );
      },
    },
    {
      header: "Work Started By",
      value: "workStartedBy",
      search: true,
    },
    {
      header: "Work Completed By",
      value: "workCompletedBy",
      search: true,
    },
    {
      header: "RIG Used",
      value: "rigUsed",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className={`mb0 mt0 fw400`}
            fontSize={14}
          >
            {Array?.isArray(obj?.rigUsed)
              ? obj?.rigUsed?.map((m: any, i: number) =>
                  i === obj?.rigUsed?.length - 1 ? m : `${m}, `
                )
              : "N/A"}
          </Text>
        );
      },
    },
    {
      header: "Pile Status",
      value: "pileStatus",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className={`mb0 mt0 fw400 capitalize ${
              obj.pileStatus === "completed with delay" && "text--danger"
            }`}
            fontSize={14}
          >
            {obj.pileStatus}
          </Text>
        );
      },
    },
    {
      header: "Pile Filling Started on",
      value: "pileFillStartedOn",
      search: true,
    },
    { header: "Pile Cycle (Hrs)", value: "pileCycleHours", search: true },
    { header: "Last Worked By", value: "workCompletedBy", search: true },
    { header: "Pile Started on", value: "pileStartedOn", search: true },
    {
      header: "Pile Completed on",
      value: "pileCompletedOn",
      search: true,
    },
    {
      header: "Delay Agency",
      value: "DelayAgency",
      search: true,
      action: function (obj: any) {
        return (
          <Grid className="delay_agency_select">
            {obj?.pileStatus === "completed with delay" ? (
              <SelectBox
                data={obj?.delay?.map((val: any) => val?.delayedAgencyName)}
                placeHolder="Select Agency"
                borderColor={"primary"}
                defaultVal={
                  obj?.delay?.map((val: any) => val?.delayedAgencyName)[0]
                }
                name="agency"
                value={() => renderValue("agency", obj.id)}
                onChange={(e) => handleChange(obj?.id, e.target.value)}
              />
            ) : (
              "N/A"
            )}
          </Grid>
        );
      },
    },
    {
      header: "Delay Reason",
      value: "delayReason",
      search: true,
      action: function (obj: any) {
        const index = getRowIndex(obj?.id);
        console.log(index !== -1 && itemsData[index]?.item?.delayReason);
        return (
          <Text
            type="normal"
            fonts="normal"
            className="mb0 mt0 fw400 capitalize"
          >
            {index !== -1 && itemsData[index]?.item?.delayReason}
          </Text>
        );
      },
    },
  ];

  return (
    <div>
      <Grid item xs={12}>
        <Grid container className="pt1">
          {/* ------Completed piles --- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <span>
              <SVG type="completeTillDate" />
            </span>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Completed Piles
              <br />
              Till Date : {completedPilesData?.totalCompletedPiles}
            </Text>
          </Grid>
          {/* ------Total Pile Length------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <span>
                <SVG type="noDataScreen" />
              </span>
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Total Pile Length :
              <br />
              {completedPilesData?.totalPileLength}
            </Text>
          </Grid>
          {/* ------ Maximum No of Delay causing agency ------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <span>
                <SVG type="maxNoDelayCauseAgency" />
              </span>
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Maximum No. of
              <br />
              Delay Causing
              <br />
              Agency :{" "}
              {completedPilesData?.maxNumberOfDelayCausingAgency?.map(
                (val: any, i: number) =>
                  i + 1 ===
                  completedPilesData?.maxNumberOfDelayCausingAgency.length
                    ? val
                    : `${val}, `
              )}
            </Text>
          </Grid>
          {/* ------Maximum delay causing agency in hrs------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <span>
                <SVG type="maxDelayCauseAgency" />
              </span>
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Maximum Delay
              <br />
              Causing Agency
              <br />
              in Hrs:{" "}
              {completedPilesData?.maxDelayCausingAgencyInHrs?.map(
                (val: any, i: number) =>
                  i + 1 ===
                  completedPilesData?.maxDelayCausingAgencyInHrs.length
                    ? val
                    : `${val}, `
              )}
            </Text>
          </Grid>
          {/* ------Overall delay in project------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center">
            <Grid className="mr">
              <span>
                <SVG type="delayTillDate" />
              </span>
            </Grid>

            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Overall Delay in
              <br />
              Project Till Date
              <br />
              {completedPilesData?.overAllDelayTillDate &&
                +completedPilesData?.overAllDelayTillDate}{" "}
              in Hrs:
            </Text>
          </Grid>
        </Grid>
      </Grid>
      {/* -------------- 1st row ---------------- */}

      <Grid container>
        <List
          listData={
            completedPilesTableData?.length > 0 ? completedPilesTableData : []
          }
          fields={fields}
          title={`Total Completed Piles Details`}
          sizeType="large"
          nodataText="No Completed piles are available"
          project={props.projectName}
          dataToDownLoad = {dataToDownload}
        />
      </Grid>

      {drawerData && (
        <Drawer
          anchor={"right"}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <PilesDrawer
            setDrawerOpen={setDrawerOpen}
            data={drawerData}
            forPage="completedpiles"
          />
        </Drawer>
      )}
    </div>
  );
};

export default CompletedPiles;
